import {Route} from 'react-router'
import LoggedRoute from '@freckle/school/ts/common/routers/logged-route'
import ManageTeachersHandler from '@freckle/school/ts/manage-teachers/components'
import GrowthHandler from '@freckle/school/ts/pages/growth/components'
import SchoolProficiencyReportHandler from '@freckle/school/ts/proficiency-report/components/school/index'
import TeacherProficiencyReportContainer from '@freckle/school/ts/proficiency-report/components/teacher'
import UsageHandler from '@freckle/school/ts/usage/components/index'

export default function RouterV2Reports() {
  return (
    <>
      <Route
        path="/dashboard"
        element={
          <LoggedRoute component={ManageTeachersHandler} wrapperParams={{tabId: 'dashboard'}} />
        }
      />
      <Route
        path="/usage/:pathSchoolId?"
        element={<LoggedRoute component={UsageHandler} wrapperParams={{tabId: 'usage'}} />}
      />
      <Route
        path="/proficiency-report/teachers/:pathTeacherId"
        element={
          <LoggedRoute
            component={TeacherProficiencyReportContainer}
            wrapperParams={{tabId: 'proficiency-report'}}
          />
        }
      />
      <Route
        path="/growth/:pathSchoolId?"
        element={<LoggedRoute component={GrowthHandler} wrapperParams={{tabId: 'growth'}} />}
      />
      <Route
        path="/proficiency-report"
        element={
          <LoggedRoute
            component={SchoolProficiencyReportHandler}
            wrapperParams={{tabId: 'proficiency-report'}}
          />
        }
      />
    </>
  )
}
